// Pub-sub bus + global exposure. This is the ONLY file that needs to run
// at app boot (via ToastContainer's import). Every other file just calls
// the global `CustomToast(status, message)` — no import required.
//C:\Users\Anish\xpr_survey\XPRSuvey-App\src\Utility\Alert\toastStore.js

let listeners = [];
let idCounter = 0;

export const subscribeToast = (listener) => {
    listeners.push(listener);
    return () => {
        listeners = listeners.filter((l) => l !== listener);
    };
};

const showToast = (status, message) => {
    if (status !== "success" && status !== "fail") {
        return;
    }
    listeners.forEach((listener) => listener({ id: ++idCounter, status, message }));
};

// Global exposure — runs once when this module is first imported
// (i.e. when App.jsx mounts <ToastContainer />).
if (typeof window !== "undefined") {
    window.CustomToast = showToast;
}